import { getPrepayCards } from '@/graphql/queries/banking/prepay-card';
import lang from '@/lang/middleware/products/banking/prepay-cards';

export default async ({ $apolloQuery, store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  const description = store.$i18n.t('results.description');
  const title = store.$i18n.t('results.jumbotron.title');
  store.commit('pageContent/setJumbotron', null);
  store.commit('pageContent/setHead', { description, title });
  await $apolloQuery(getPrepayCards).then(cards => store.commit('products/setList', cards));
};
